'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import useUserAttribute from '../../hooks/useUserAttribute';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `RichTextLib.newFeatures.${key}`;
function NewFeatureShepherd(props) {
  const {
    children,
    placement,
    width = 350,
    header,
    body,
    getUserAttributes,
    setUserAttribute,
    settingsKey,
    shouldShow = true
  } = props;
  const [attributeLoaded, hasAttribute, setHasAttribute] = useUserAttribute(getUserAttributes, setUserAttribute, settingsKey, true);
  const showShepherd = shouldShow && attributeLoaded && !hasAttribute;
  return /*#__PURE__*/_jsx(Popover, {
    tabIndex: "-1",
    "data-test-id": `new-feature-popover-${settingsKey}`,
    use: "shepherd",
    placement: placement,
    autoPlacement: "horiz",
    open: showShepherd,
    inlineSize: width,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        fontWeight: "bold",
        children: header
      }),
      body,
      footer: /*#__PURE__*/_jsx(Button, {
        onClick: () => setHasAttribute(true),
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('confirm')
        })
      })
    },
    children: children
  });
}
NewFeatureShepherd.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  settingsKey: PropTypes.string.isRequired,
  getUserAttributes: PropTypes.func.isRequired,
  setUserAttribute: PropTypes.func.isRequired,
  shouldShow: PropTypes.bool,
  width: PropTypes.number,
  placement: PropTypes.string
};
export default NewFeatureShepherd;